<template>
    <nav
        class="navbar primary navbar-expand-lg weeduc-admin-toolbar"
        :class="{ 'weeduc-admin-toolbar--dark': dark }"
    >
        <div class="toolbar-goback" @click="goBack">
            <fa icon="fa-arrow-left"/>
        </div>
        <div class="container">
            <div class="navbar-wrapper primary">
                <div class="wrapper-inner">
                    <div class="navbar-breadcrumb">
                        <ul class="breadcrumb">
                            <li v-for="(item, index) in items" :key="index"
                                :class="{ 'breadcrumb-item': true, 'active': item.active }">
                                <router-link v-if="!item.active" class="link-breadcrumb" :to="item.link">
                                    {{ item.label }}
                                </router-link>
                                <span v-else>{{ item.label }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="wrapper-inner">
                    <ul class="navbar-nav primary">
                        <li @click="changeSideBarState()" class="mobileClickMenu">
                            <a href="#">
                                <fa icon="fa-bars"/>
                            </a>
                        </li>
                        <li v-if="showPublicSiteLink">
                            <a :href="websites.url" target="_blank" class="link-toolbar">
                                <svg class="icon-default" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 464C141.1 464 48 370.9 48 256c0-22 3.4-43.1 9.7-63l9.4 16.4c8.3 14.5 21.9 25.2 38 29.8L163 255.7c17.2 4.9 29 20.6 29 38.5l0 39.9c0 11 6.2 21 16 25.9s16 14.9 16 25.9l0 30.4c0 15.9 15.2 27.3 30.5 23c15.9-4.5 28.3-17 32.8-32.8l1.5-5.4c4.6-16.1 15.3-29.7 29.8-38l9.2-5.3c15-8.5 24.2-24.5 24.2-41.7l0-8.3c0-12.7-5.1-24.9-14.1-33.9l-3.9-3.9c-9-9-21.2-14.1-33.9-14.1L257 256c-11.1 0-22.1-2.9-31.8-8.4l-34.5-19.7c-4.3-2.5-7.6-6.5-9.2-11.2c-3.2-9.6 1.1-20 10.2-24.5l5.9-3c6.6-3.3 14.3-3.9 21.3-1.5l23.2 7.7c8.2 2.7 17.2-.4 21.9-7.5c4.7-7 4.2-16.3-1.2-22.8l-13.6-16.3c-10-12-9.9-29.5 .3-41.3l15.7-18.3c8.8-10.3 10.2-25 3.5-36.7l-2.4-4.2c73.6 3.6 137.2 45.6 171.2 106.3L412 164.8c-15.7 6.3-23.8 23.8-18.5 39.8l16.9 50.7c3.5 10.4 12 18.3 22.6 20.9l29.1 7.3C448.7 385.4 361.5 464 256 464zm0 48A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"/></svg>
                                <span class="link-text">{{ $t('toolbar.viewSite') }}</span>
                            </a>
                        </li>
                        <li v-if="canPreviewAs">
                            <a href="#" class="link-toolbar" @click.prevent="openPreviewAs = true">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"/></svg>
                                <span class="link-text">{{ $t('toolbar.previewAs') }}</span>
                            </a>
                        </li>
                        <li v-if="showStudentPortalLink">
                            <a href="/aluno/dashboard" class="link-toolbar" @click="openStudentPortal">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M320 80c2.5 0 5 .4 7.4 1.3l218 78.7-218 78.7c-2.4 .9-4.9 1.3-7.4 1.3s-5-.4-7.4-1.3L184.9 192.6l140.8-52.8c8.3-3.1 12.5-12.3 9.4-20.6s-12.3-12.5-20.6-9.4L154.9 169.6c-5.2 2-10.3 4.2-15.3 6.6L94.7 160l218-78.7c2.4-.9 4.9-1.3 7.4-1.3zM15.8 182.6l77.4 27.9c-27.2 28.7-43.7 66.7-45.1 107.7c-.1 .6-.1 1.2-.1 1.8c0 28.4-10.8 57.8-22.3 80.8c-6.5 13-13.9 25.8-22.5 37.6C0 442.7-.9 448.3 .9 453.4s6 8.9 11.2 10.2l64 16c4.2 1.1 8.7 .3 12.4-2s6.3-6.1 7.1-10.4c8.6-42.8 4.3-81.2-2.1-108.7c-3.2-14-7.5-28.3-13.4-41.5c1.9-37 19.2-70.9 46.7-94.2l169.5 61.2c7.6 2.7 15.6 4.1 23.7 4.1s16.1-1.4 23.7-4.1L624.2 182.6c9.5-3.4 15.8-12.5 15.8-22.6s-6.3-19.1-15.8-22.6L343.7 36.1C336.1 33.4 328.1 32 320 32s-16.1 1.4-23.7 4.1L15.8 137.4C6.3 140.9 0 149.9 0 160s6.3 19.1 15.8 22.6zm480.8 80l-46.5 16.8 12.7 120.5c-4.8 3.5-12.8 8-24.6 12.6C410 423.6 368 432 320 432s-90-8.4-118.3-19.4c-11.8-4.6-19.8-9.2-24.6-12.6l12.7-120.5-46.5-16.8L128 408c0 35.3 86 72 192 72s192-36.7 192-72L496.7 262.6zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z"/></svg>
                                <span class="link-text">{{ $t('toolbar.studentPortal') }}</span>
                            </a>
                        </li>
                        <li class="nav-item icon-toolbar">
                            <a class="nav-icon" @click="toggleDarkModeFunction()"> 
                                <fa icon="sun" v-show="dark"/>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="weeduc-toolbar-theme-icon" v-show="!dark">
                                    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
                                </svg>
                            </a>
                        </li>
                        <li class="nav-item dropdown user-avatar" @click="toggleDropdown">
                            <a class="nav-link dropdown-toggle">
                                <img class="image-user" :src="user && user.photoFinal ? user.photoFinal : '/img/user.e69f11a5.png'" />
                                <span v-if="user && user.firstName && user.lastName">
                                    {{ user.firstName.charAt(0) }}{{ user.lastName.charAt(0) }}
                                </span>
                            </a>
                            <ul class="dropdown-menu" :class="{ show: isDropdownOpen }" ref="dropdownMenu">
                                <li class="dropdown-item">
                                    <a class="link-dropdown" @click="gotoUserEdit">{{ $t('toolbar.editProfile') }}</a>
                                </li>
                                <li class="dropdown-item">
                                    <a class="btn btn-block btn-dropdown" @click="logout">{{ $t('toolbar.logout') }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>

    <EditUser
        v-if="openmodaledituser"
        :show="openmodaledituser"
        :id="user.id"
        @open-tab="atualizarValorNoFilhoEdit"
    />

    <PreviewAsDialog v-if="canPreviewAs" v-model="openPreviewAs" />
</template>

<script>
import store from '@/store';
import { mapState, mapActions } from 'vuex';
import EditUser from '@/components/Admin/Users/Edituser/edituser.vue';
import PreviewAsDialog from '@/components/Admin/Corporate/PreviewAsDialog.vue';
import { isCorporateEnvironment, isPublicSiteEnabled } from '@/utils/corporate/environment';
import { canPreviewAsCollaborator } from '@/utils/corporate/permissions';
import {
    ADMIN_DASHBOARD_MODE,
    getAdminDashboardMode,
} from '@/utils/corporate/adminDashboardMode';

export default {
    props: {
        items: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            typeUser: 0,
            openmodaledituser: false,
            isDropdownOpen: false,
            openPreviewAs: false,
        };
    },
    computed: {
        ...mapState(['dark', 'user', 'websites', 'sideBarState', 'company', 'adminDashboardMode']),
        dashboardMode() {
            return getAdminDashboardMode();
        },
        showPublicSiteLink() {
            return !isCorporateEnvironment() || isPublicSiteEnabled();
        },
        canPreviewAs() {
            return isCorporateEnvironment()
                && this.dashboardMode === ADMIN_DASHBOARD_MODE.CORPORATIVO
                && canPreviewAsCollaborator();
        },
        showStudentPortalLink() {
            return this.dashboardMode !== ADMIN_DASHBOARD_MODE.CORPORATIVO;
        },
    },
    components: {
        EditUser,
        PreviewAsDialog,
    },
    methods: {
        ...mapActions([
            'storeTypeId',
            'storeDark',
            'toggleDarkMode',
            'storeSideBarState',
        ]),
        logout() {
            localStorage.removeItem('vuex');
            localStorage.removeItem('activeIndex');
            localStorage.removeItem('logado');
            window.location.href = "/login";
        },
        toggleDarkModeFunction() {
            this.toggleDarkMode({ dark: !this.dark });
        },
        goBack(){
            window.history.back();
        },
        atualizarValorNoFilhoEdit(novovalor) {
            this.openmodaledituser = novovalor;
        },
        changeSideBarState() {
            this.storeSideBarState({ sideBarState: !this.sideBarState });
        },
        gotoUserEdit() {
            this.$router.push('/dashboard/form-usuario/' + this.user.id);
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        openStudentPortal(event) {
            event.preventDefault();
            this.$router.push('/aluno/dashboard');
        },
    },
    created() {
        this.typeUser = store.state.typeId;
        if (
            isCorporateEnvironment()
            && (this.$route?.path || '').startsWith('/dashboard/corporativo')
            && getAdminDashboardMode() !== ADMIN_DASHBOARD_MODE.CORPORATIVO
        ) {
            setAdminDashboardMode(ADMIN_DASHBOARD_MODE.CORPORATIVO);
        }
    },
};
</script>

<style scoped>
.toolbar-goback {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    cursor: pointer;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    transition: background 0.2s ease;
}

.admin-data-source-toggle {
    display: flex;
    align-items: center;
    margin-right: 0.35rem;
}

.admin-data-source-toggle__btn {
    height: 36px;
    padding: 0 0.75rem;
    border: 1px solid transparent;
    border-radius: 10px;
    font-family: "Inter", sans-serif;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    cursor: pointer;
    line-height: 1;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.admin-data-source-toggle__btn.is-api {
    background: #e8f5e9;
    border-color: #a5d6a7;
    color: #1b5e20;
}

.admin-data-source-toggle__btn.is-mock {
    background: #fff8e1;
    border-color: #ffe082;
    color: #f57f17;
}

.weeduc-admin-toolbar--dark .admin-data-source-toggle__btn.is-api {
    background: rgba(46, 125, 50, 0.25);
    border-color: rgba(165, 214, 167, 0.45);
    color: #a5d6a7;
}

.weeduc-admin-toolbar--dark .admin-data-source-toggle__btn.is-mock {
    background: rgba(245, 127, 23, 0.22);
    border-color: rgba(255, 224, 130, 0.4);
    color: #ffe082;
}

.toolbar-goback:hover {
    background: rgba(37, 8, 145, 0.08);
}

.toolbar-goback svg {
    color: #250891;
    font-size: 18px !important;
}

.dashboard.dark .toolbar-goback:hover {
    background: rgba(255, 255, 255, 0.08);
}

.dashboard.dark .toolbar-goback svg {
    color: #c4b5fd;
}

.container {
    box-shadow: none !important;
    max-width: 95%;
}

.navbar {
    --bs-navbar-padding-y: 0 !important;
}

/* Barra superior — alinhada ao shell admin Weflix */
.weeduc-admin-toolbar.navbar.primary {
    background: linear-gradient(180deg, #fafbff 0%, #ffffff 52%);
    border-bottom: 1px solid #e8eaf0;
    box-shadow: 0 1px 3px rgba(37, 8, 145, 0.05);
    width: 100% !important;
    min-height: 58px;
}

/* Tema escuro: classe no próprio nav (evita falha de scoped com ancestral .dashboard) */
.weeduc-admin-toolbar.weeduc-admin-toolbar--dark.navbar.primary {
    background: linear-gradient(180deg, #23252e 0%, #1c1d24 55%);
    border-bottom-color: #353945;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
}

.weeduc-admin-toolbar.weeduc-admin-toolbar--dark.navbar.primary > .container,
.weeduc-admin-toolbar.weeduc-admin-toolbar--dark .navbar-wrapper.primary {
    background: transparent;
}

.navbar.primary > .container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    max-width: 100%;
}

.navbar > .container {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between;
}

.navbar.primary .navbar-wrapper.primary {
    display: flex;
    align-items: center;
    width: 100% !important;
    justify-content: space-between;
    flex-direction: row;
    padding: 0.45rem 0;
    gap: 1rem;
}

.navbar.primary .navbar-wrapper.primary > .wrapper-inner {
    display: flex;
    align-items: center;
    min-height: 44px;
}

.navbar.primary .navbar-nav.primary {
    display: flex;
    align-items: center;
    flex-direction: row !important;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    gap: 0.35rem;
    justify-content: flex-end;
}

.navbar.primary .navbar-breadcrumb .breadcrumb {
    padding: 0 !important;
    margin: 0 !important;
}

.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item {
    padding: 0 !important;
}

.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item:first-child .link-breadcrumb {
    padding-left: 0 !important;
}

.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb {
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
    font-family: 'Inter', system-ui, sans-serif;
    font-weight: 500;
    font-size: 13.5px;
    line-height: 1.4;
    text-decoration: none;
    color: #6b7280;
    transition: color 0.2s ease;
}

.dashboard.dark .navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb {
    color: #9ca3b4;
}

.navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb.active {
    color: #1a1d26;
}

.dashboard.dark .navbar.primary .navbar-breadcrumb .breadcrumb .breadcrumb-item .link-breadcrumb.active {
    color: #f1f3f7;
}

/* Links externos — estilo pill */
.navbar-nav.primary .link-toolbar {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.42rem 0.85rem;
    border-radius: 10px;
    border: 1px solid #e8eaf0;
    background: rgba(255, 255, 255, 0.85);
    color: #1f1e61;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    transition:
        border-color 0.2s ease,
        background 0.2s ease,
        color 0.2s ease,
        box-shadow 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.navbar-nav.primary .link-toolbar:hover {
    color: #250891;
    border-color: rgba(37, 8, 145, 0.35);
    background: rgba(37, 8, 145, 0.06);
    box-shadow: 0 2px 8px rgba(37, 8, 145, 0.08);
}

.navbar-nav.primary .link-toolbar svg {
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    color: #250891;
    fill: #250891;
    vertical-align: middle;
}

.navbar-nav.primary .link-toolbar .link-text {
    white-space: nowrap;
}

.dashboard.dark .navbar-nav.primary .link-toolbar {
    background: rgba(42, 45, 54, 0.9);
    border-color: #3d414d;
    color: #e8eaf0;
    box-shadow: none;
}

.dashboard.dark .navbar-nav.primary .link-toolbar:hover {
    border-color: #6d5acd;
    background: rgba(109, 90, 205, 0.12);
    color: #fff;
}

.dashboard.dark .navbar-nav.primary .link-toolbar svg {
    color: #c4b5fd;
    fill: #c4b5fd;
}

/* Menu mobile — botão ícone */
.mobileClickMenu a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    border: 1px solid #e8eaf0;
    background: #fff;
    color: #250891;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.mobileClickMenu a:hover {
    background: rgba(37, 8, 145, 0.06);
    border-color: rgba(37, 8, 145, 0.25);
}

.dashboard.dark .mobileClickMenu a {
    background: rgba(42, 45, 54, 0.9);
    border-color: #3d414d;
    color: #e8eaf0;
}

.mobileClickMenu a svg {
    height: 18px;
    width: 18px;
}

/* Tema claro/escuro */
.nav-item.icon-toolbar .nav-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 35px;
    border-radius: 10px;
    border: 1px solid #e8eaf0;
    background: #fff;
    color: #250891;
    transition:
        background 0.2s ease,
        border-color 0.2s ease,
        color 0.2s ease;
}

.nav-item.icon-toolbar .nav-icon:hover {
    background: rgba(37, 8, 145, 0.08);
    border-color: rgba(37, 8, 145, 0.3);
}

.nav-item.icon-toolbar .nav-icon .weeduc-toolbar-theme-icon {
    color: #250891;
}

.dashboard.dark .nav-item.icon-toolbar .nav-icon {
    background: rgba(42, 45, 54, 0.9);
    border-color: #3d414d;
    color: #e8eaf0;
}

.dashboard.dark .nav-item.icon-toolbar .nav-icon .weeduc-toolbar-theme-icon {
    color: #e8eaf0;
}

li.nav-item {
    cursor: pointer !important;
}

li.nav-item.icon-toolbar i {
    color: #250891;
    font-size: 18px;
}

.dashboard.dark li.nav-item.icon-toolbar i {
    color: #e8eaf0;
}

/* Avatar + dropdown trigger */
.user-avatar .nav-link.dropdown-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.2rem 0.55rem 0.2rem 0.2rem;
    border-radius: 999px;
    border: 1px solid #e8eaf0;
    background: rgba(255, 255, 255, 0.9);
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.user-avatar .nav-link.dropdown-toggle:hover {
    border-color: rgba(37, 8, 145, 0.35);
    box-shadow: 0 2px 10px rgba(37, 8, 145, 0.1);
}

:is(.dashboard.dark, .weeduc-admin-toolbar--dark) .user-avatar .nav-link.dropdown-toggle {
    background: rgba(42, 45, 54, 0.95);
    border-color: #3d414d;
    color: #e8eaf0;
}

:is(.dashboard.dark, .weeduc-admin-toolbar--dark) .user-avatar .nav-link.dropdown-toggle span {
    color: inherit;
}

:is(.dashboard.dark, .weeduc-admin-toolbar--dark) .user-avatar .nav-link.dropdown-toggle:hover {
    border-color: rgba(255, 255, 255, 0.55);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.28);
    color: #ffffff;
}

:is(.dashboard.dark, .weeduc-admin-toolbar--dark) .user-avatar .nav-link.dropdown-toggle:hover::after {
    border-top-color: #ffffff !important;
}

.image-user {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid rgba(37, 8, 145, 0.12);
}

.dashboard.dark .image-user {
    border-color: rgba(199, 182, 254, 0.35);
}

ul.navbar-nav.primary li {
    margin: 0;
    cursor: pointer;
    position: relative;
    list-style: none;
}

ul.navbar-nav.primary li a {
    text-decoration: none;
    position: relative;
}

svg.svg-inline--fa {
    font-size: 16px !important;
}

/* Dropdown */
.dropdown-menu {
    position: absolute;
    top: calc(100% + 8px) !important;
    right: 0 !important;
    min-width: 200px;
    padding: 0.4rem !important;
    border-radius: 12px !important;
    border: 1px solid #e8eaf0 !important;
    box-shadow:
        0 10px 40px rgba(15, 10, 40, 0.12),
        0 2px 8px rgba(0, 0, 0, 0.04) !important;
    overflow: hidden;
}

.dashboard.dark .dropdown-menu {
    background: #2a2d36 !important;
    border-color: #3d414d !important;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45) !important;
}

.dropdown-item {
    width: 100%;
    margin: 0;
    padding: 0 !important;
    border-radius: 8px;
}

.dropdown-item .link-dropdown {
    display: block;
    padding: 0.65rem 0.85rem !important;
    color: #374151 !important;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    transition: background 0.15s ease, color 0.15s ease;
}

.dropdown-item .link-dropdown:hover {
    background: rgba(37, 8, 145, 0.08) !important;
    color: #250891 !important;
}

.dashboard.dark .dropdown-item .link-dropdown {
    color: #e8eaf0 !important;
}

.dashboard.dark .dropdown-item .link-dropdown:hover {
    background: rgba(109, 90, 205, 0.2) !important;
    color: #fff !important;
}

.btn:last-child {
    width: 100%;
    text-align: center;
    background: linear-gradient(135deg, #2f1a8c 0%, #250891 100%);
    color: #fff !important;
    border: none;
    border-radius: 8px;
    padding: 0.55rem 0.85rem !important;
    font-weight: 600;
    margin-top: 0.25rem;
}

.btn:last-child:hover {
    background: linear-gradient(135deg, #3d24a8 0%, #3219a8 100%);
    color: #fff !important;
}

.dropdown-item:hover {
    background: transparent !important;
}

.dropdown-item:focus {
    background: transparent !important;
}

@media (min-width: 600px) {
    .mobileClickMenu {
        display: none;
    }
}

@media (max-width: 600px) {
    .weeduc-admin-toolbar .navbar-nav.primary {
        gap: 0.25rem;
    }

    .weeduc-admin-toolbar .navbar-nav.primary li a .link-text {
        display: none;
    }

    .weeduc-admin-toolbar .navbar-nav.primary .link-toolbar {
        padding: 0.42rem;
        min-width: 40px;
        justify-content: center;
    }

    .weeduc-admin-toolbar .container {
        max-width: 100%;
        padding: 0 10px;
    }

    .weeduc-admin-toolbar .navbar-wrapper.primary {
        gap: 8px;
    }

    .navbar-nav .dropdown-menu {
        position: absolute !important;
    }
}
</style>